import { EventBroker } from "@frontend/lib/utils/event-broker";

export const SALSIFY_EVENTS = {
    HANDLE_COPY_TO_SALSIFY: 'HANDLE_COPY_TO_SALSIFY'
};

export const salsifyEventBroker = new EventBroker();
